type THttpError<Data = unknown> = {
    data?: Data;
    headers?: Record<string, unknown>;
    request: unknown;
    status?: number;
    /** @deprecated используйте свойство `status` */
    statusCode?: number;
    statusText?: string;
};

export class HttpError<Data = unknown> extends Error {
    status?: number;

    /** @deprecated используйте свойство `status` */
    statusCode?: number;

    data?: Data;

    statusText?: string;

    headers?: Record<string, unknown>;

    request?: unknown;

    constructor(
        message: string,
        { data, headers, request, status, statusCode, statusText }: THttpError<Data>
    ) {
        super(message);
        this.name = 'HttpError';
        this.status = status;
        this.statusCode = statusCode;
        this.statusText = statusText;
        this.data = data;
        this.headers = headers;
        this.request = request;
    }
}
